// images
import mainPlumbing1 from "../assets/mainPage/mainPlumbing1.webp";
import vybiraemvannu1 from "../assets/otherPages/plumbing/vybiraem_vannu_1.webp";
import vybiraemvannu2 from "../assets/otherPages/plumbing/vybiraem_vannu_2.webp";
import vybiraemvannu3 from "../assets/otherPages/plumbing/vybiraem_vannu_3.webp";

import mainPlumbing2 from "../assets/mainPage/mainPlumbing2.webp";
import vybiraemmoiku1 from "../assets/otherPages/plumbing/vybiraem_moiku_1.webp";
import vybiraemmoiku2 from "../assets/otherPages/plumbing/vybiraem_moiku_2.webp";
import vybiraemmoiku3 from "../assets/otherPages/plumbing/vybiraem_moiku_3.webp";

import mainPlumbing3 from "../assets/mainPage/mainPlumbing3.webp";
import vyborsmes1 from "../assets/otherPages/plumbing/vybor_smesitel_1.webp";
import vyborsmes2 from "../assets/otherPages/plumbing/vybor_smesitel_2.webp";

import unitaz1 from "../assets/otherPages/plumbing/unitaz1.webp";
import unitaz2 from "../assets/otherPages/plumbing/unitaz2.webp";
import unitaz3 from "../assets/otherPages/plumbing/unitaz3.webp";

// plumbing articles
export const plumbingArticles = [
  // ARTICLE 1 START
  {
    id: "Выбираем ванну",
    img: mainPlumbing1,
    pretitle: "Сантехника",
    title: "Выбираем ванну",
    tagString: "ванна сантехника ванная смеситель",
    tags: [
      {
        tag: "ванна",
        tagLink: "#",
      },
      {
        tag: "сантехника",
        tagLink: "#",
      },
      {
        tag: "ванная",
        tagLink: "#",
      },
      {
        tag: "смеситель",
        tagLink: "#",
      },
    ],
    linkToArticle: "/plumbing/Выбираем ванну",
    text: [
      {
        attribute: "paragraph",
        content:
          "Ванна - важнейший предмет сантехники, выполняющий не только гигиенические функции, но и восстанавливающие и оздоровительные. Выбирая ванну помимо материала, габаритов и формы, влияющих на общий интерьер ванной комнаты, не стоит забывать о технических возможностях подключения коммуникаций. Всю необходимую арматуру (сифон, слив-перелив), если не входят в комплектацию, а также смеситель, следует приобретать одновременно с ванной, для обеспечения надлежащей совместимости. Не допустимо наличие вмятин, трещин и сколов.",
      },
      {
        attribute: "image",
        content: vybiraemvannu1,
      },
      {
        attribute: "paragraph",
        content:
          "Стальные ванны изготовляют из двух видов стали: нержавеющей и конструкционной. Толщина стенки колеблется от 1,5 до 4,5 мм и может покрываться как простой эмалью, так и кварцевой, которая практически не царапается. Вес 25-50 кг. Размеры длина 150-180 см, ширина 70-85 см.",
      },
      {
        attribute: "list",
        content: [
          {
            item: "достоинства: разнообразие размеров и форм; прочность эмали; долговечность",
          },
          {
            item: "недостатки: легко деформируется; быстро остывает; требует надёжной фиксации; низкая шумоизоляция",
          },
        ],
      },
      {
        attribute: "image",
        content: vybiraemvannu2,
      },
      {
        attribute: "paragraph",
        content:
          "Чугунные ванны долговечны, прекрасно сохраняют тепло, устойчивы. Толщина стенок доходит до 8 мм, у импортных не более 5 мм. Размеры 140-150 на 70 см.",
      },
      {
        attribute: "list",
        content: [
          {
            item: "достоинства: прочный эмалевый слой; теплоёмкость; прочность конструкции; длительность эксплуатации: более 30 лет, в зависимости от ухода",
          },
          {
            item: "недостатки: вес до 150 кг; малое разнообразие форм и размеров; легко скалывается эмаль; может скользить, поэтому следует выбирать ванну со специальным покрытием",
          },
        ],
      },
      {
        attribute: "image",
        content: vybiraemvannu3,
      },
      {
        attribute: "paragraph",
        content:
          "Акриловые ванны объединяют в себе лучшие качества стальных и чугунных ванн. Толщина стенок составляет 7-9 мм, вес от 15 до 35 кг. Много моделей с  дополнительными функциями. Прочность зависит от количества слоёв армирования, которые хорошо видны на краю бортика. Ванны в зависимости от формы имеют размеры: длину 120-190    и ширину 70-170 см.",
      },
      {
        attribute: "list",
        content: [
          {
            item: "достоинства: большой выбор форм и размеров; удобная в транспортировке и установке; быстрый нагрев и долгое остывание; не скользкая поверхность; срок службы до 10-15 лет",
          },
          {
            item: "недостатки: легко царапается; чувствительна к моющим средствам и высоким температурам",
          },
        ],
      },
    ],
  },
  // ARTICLE 1 END

  // ARTICLE 2 START
  {
    id: "Выбираем мойку для кухни",
    img: mainPlumbing2,
    pretitle: "Сантехника",
    title: "Выбираем мойку для кухни",
    tagString: "кухня сантехника мойка смеситель излив",
    tags: [
      {
        tag: "кухня",
        tagLink: "#",
      },
      {
        tag: "сантехника",
        tagLink: "#",
      },
      {
        tag: "мойка",
        tagLink: "#",
      },
      {
        tag: "смеситель",
        tagLink: "#",
      },
      {
        tag: "излив",
        tagLink: "#",
      },
    ],
    linkToArticle: "/plumbing/Выбираем мойку для кухни",
    text: [
      {
        attribute: "paragraph",
        content:
          "Практически все кухонные мойки, имеющиеся в продаже обладают высокой прочностью, устойчивостью к агрессивным моющим средствам, перепадам температур. Поэтому выбирая мойку, следует руководствоваться такими параметрами как размер, форма, цвет, а также сложность монтажа.",
      },
      {
        attribute: "image",
        content: vybiraemmoiku1,
      },
      {
        attribute: "paragraph",
        content:
          "Выбирая мойку следует учитывать размер пространства, в которое она будет монтироваться. Наиболее компактными являются мойки с одной чашей. Также относительно компактны полуторные чаши. Эти виды моек подойдут для небольших кухонь.",
      },
      {
        attribute: "image",
        content: vybiraemmoiku2,
      },
      {
        attribute: "paragraph",
        content:
          "Угловые, а также мойки с двумя, тремя чашами отличный вариант для большой семьи, но и размер кухни должен соответствовать данному варианту.",
      },
      {
        attribute: "paragraph",
        content:
          "Существенно добавляют разнообразия мойкам так называемые «крылья» - это дополнительная поверхность может располагаться как с одной, так и с двух сторон от чаш мойки.",
      },
      {
        attribute: "image",
        content: vybiraemmoiku3,
      },
      {
        attribute: "paragraph",
        content:
          "Стоит упомянуть о соотношении глубины чаши с видом устанавливаемого смесителя. Для смесителя с горизонтальным изливом необходима максимально глубокая чаша, чтобы было меньше брызг. Тогда как неглубокие мойки отлично подходят для высоких смесителей с вертикальным изливом.",
      },
      {
        attribute: "paragraph",
        content:
          "Осталось сказать о материале, от которого зависят стоимость и эксплуатационные характеристики кухонной мойки. Наиболее практичный вариант это мойки из композитных материалов таких как акрил, гранитная крошка и силикатный кварц. Благодаря большому ассортименту цветов и оттенков такую мойку можно гармонично вписать в любой кухонный гарнитур. Кроме этого они долговечны, легко моются, обладают хорошим шумоподавлением.Преимуществом керамических(фарфоровых, фаянсовых) раковин является их долговечность, высокая стойкость к царапинам, температурам, агрессивным средам. Но хрупкость и большой вес, создающими сложности при монтаже, являются явными недостатками. Самые же популярные мойки — стальные, благодаря своей гигиеничности, долговечности и небольшому весу.",
      },
    ],
  },
  // ARTICLE 2 END

  // ARTICLE 3 START
  {
    id: "Выбор смесителя для кухни",
    img: mainPlumbing3,
    pretitle: "Сантехника",
    title: "Выбор смесителя для кухни",
    tagString: "ванна сантехника ванная смеситель",
    tags: [
      {
        tag: "кухня",
        tagLink: "#",
      },
      {
        tag: "сантехника",
        tagLink: "#",
      },
      {
        tag: "мойка",
        tagLink: "#",
      },
      {
        tag: "смеситель",
        tagLink: "#",
      },
      {
        tag: "излив",
        tagLink: "#",
      },
    ],
    linkToArticle: "/plumbing/Выбор смесителя для кухни",
    text: [
      {
        attribute: "paragraph",
        content:
          "Предлагаем вашему вниманию краткое руководство по выбору смесителя для кухни, которое поможет вам сориентироваться в огромном выборе представленных сегодня на рынке моделей и подобрать отвечающий именно вашим требованиям.",
      },
      {
        attribute: "title",
        content: "Материал изготовления",
      },
      {
        attribute: "paragraph",
        content:
          "Наиболее предпочтительным являются латунные и бронзовые смесители не только из-за своей высокой износостойкости, но и отличного внешнего вида. Модели из силумина — сплава кремния с алюминием, дешевле, но не рекомендуются к приобретению из-за их недолговечности. Ещё один экономичный вариант это смесители из пластика, обладающие высокой стойкостью к агрессивным химическим средам, вряд ли прослужат долго по причине непрочности своей конструкции. Керамические модели прекрасно подойдут для мойки из керамогранита или камня. По своим эксплуатационным свойствам керамические смесители уступают моделям из металлов.",
      },
      {
        attribute: "title",
        content: "Типы конструкций",
      },
      {
        attribute: "paragraph",
        content:
          "Существует три типа смесителей: однорычажный, двухвентильный а также термостатические(бесконтактные) модели. Далее подробнее об их особенностях.",
      },
      {
        attribute: "image",
        content: vyborsmes1,
      },
      {
        attribute: "paragraph",
        content:
          "Однорычажные смесители наиболее востребованы, благодаря удобству использования. Включить или выключить, а также отрегулировать температуру и уровень подачи воды, можно одной рукой и даже предплечьем если, например, руки грязные.",
      },
      {
        attribute: "paragraph",
        content:
          "Двухвентильные модели теряют свою популярность из-за невысоких показателей практичности и долговечности. Тем не менее они являются неотъемлемой частью авторских кухонь в классическом стиле.",
      },
      {
        attribute: "paragraph",
        content:
          "Термостатические же модели напротив набирают популярность. Принцип работы довольно прост: при поднесении руки к специальному датчику льётся вода заранее установленной температуры.",
      },
      {
        attribute: "image",
        content: vyborsmes2,
      },
      {
        attribute: "paragraph",
        content:
          "Также выбор смесителя, а именно тип излива(высокий или низкий, поворотный, выдвижной), напрямую зависит от глубины и количества чаш кухонной мойки. Высокий излив подходит для глубоких чаш, тогда как модель с низким изливом более универсальна и подойдёт для любой мойки. Поворотный излив с широким углом поворота отличное решение для двухсекционной мойки. Выдвижной излив позволяет использовать струю воды в гораздо большем диапазоне, благодаря шлангу длиной от 70 до 80 см.",
      },
    ],
  },
  // ARTICLE 3 END

  // ARTICLE 4 START
  {
    id: "Что необходимо знать, выбирая унитаз",
    img: unitaz1,
    pretitle: "Сантехника",
    title: "Что необходимо знать, выбирая унитаз",
    tagString: "сантехника унитаз",
    tags: [
      {
        tag: "сантехника",
        tagLink: "#",
      },
      {
        tag: "унитаз",
        tagLink: "#",
      },
    ],
    linkToArticle: "/plumbing/Что необходимо знать, выбирая унитаз",
    text: [
      {
        attribute: "paragraph",
        content:
          "Выбирая унитаз, необходимо учитывать не только стоимость, производителя, материал, цвет и внешний вид, но и менее очевидные параметры, такие как установка и обслуживание.",
      },
      {
        attribute: "image",
        content: unitaz2,
      },
      {
        attribute: "paragraph",
        content:
          "Первое на что следует обратить внимание это размеры помещения, где будет установлен унитаз. При дефиците пространства следует отдавать предпочтение подвесным моделям, а также унитазам без  бачков у которых смывочные устройства устанавливаются непосредственно на трубу водопровода. Ещё одна важнейшая характеристика — тип смывания воды: прямое или круговое. Более предпочтительным является круговой слив, который из-за более сильного напора воды лучше омывает раковину. Что касается других моделей то наиболее популярными остаются «компакты», с установкой сливного бачка на унитазе, где подача воды осуществляется либо снизу, либо сбоку. Из-за практически бесшумной подачи, следует остановить свой выбор на нижнем подведении воды. Унитаз-моноблок, имея самые внушительные габариты, подойдёт для санузла большой площади.",
      },
      {
        attribute: "paragraph",
        content:
          "Основными материалами изготовления являются фаянс и фарфор, кроме того существуют модели из чугуна, стали, пластика и стекла. Фарфор в сравнении с фаянсом обладает меньшей пористостью и меньше впитывает запахи и воду(менее1%, у фаянса 10% и более), что влияет на долговечность использования.",
      },
      {
        attribute: "image",
        content: unitaz3,
      },
      {
        attribute: "paragraph",
        content:
          "Далее рассмотрим варианты сливных конструкций: горизонтальный, косой и вертикальный. Самым универсальным из всех является — горизонтальный, позволяющий при помощи специального переходника, вывести трубу в стену или в пол. Косая сливная конструкция(угол 30-40), позволяет расположить унитаз максимально близко к стене, что подойдёт для небольших санузлов.",
      },
      {
        attribute: "paragraph",
        content:
          "Также при покупке унитаза необходимо убедиться в полной комплектации арматуры сливного бачка и крепёжных элементов.",
      },
    ],
  },
  // ARTICLE 4 END
];
